/* eslint-disable react/jsx-key */
import { Box, Flex, Grid, GridItem, HStack, Text, useBreakpoint } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import React from "react";
import Calendly from "~/components/calendly";
const SmallBreak = () => {
  const breakpoint = useBreakpoint();
  return <br style={{ display: breakpoint === "base" ? "block" : "none" }} />;
};
const Offer = () => {
  const offers: JSX.Element[] = [
    <React.Fragment>
      Consistent coaching updates <SmallBreak /> for managers
    </React.Fragment>,
    <React.Fragment> One free group coaching</React.Fragment>,
    <React.Fragment> Pre and Post 360 Degree Feedback</React.Fragment>,
    <React.Fragment> Free coaching worksheets</React.Fragment>,
    <React.Fragment> Need-based assessment for coaching specializations</React.Fragment>,
  ];
  return (
    <Box
      bgColor="#0D3050"
      color="white"
      py={{ xl: "100px", lg: "80px", base: "64px" }}
      w="full"
      fontFamily="'Inter', sans-serif"
    >
      <Flex
        px={{ xl: "160px", lg: "24px", base: "16px" }}
        direction={"column"}
        maxWidth={"1440px"}
        mx="auto"
      >
        <Text
          mb="20px"
          fontSize={{ lg: "18px", base: "14px" }}
          lineHeight={{ lg: "18px", base: "14px" }}
          letterSpacing={"0.05em"}
        >
          OFFER
        </Text>
        <Text
          fontSize={{ lg: "56px", base: "24px" }}
          lineHeight={{ lg: "64px", base: "28px" }}
          fontFamily={"Georgia"}
          w={{ lg: "943px" }}
          letterSpacing={{ base: "-0.02em" }}
          mb={"40px"}
        >
          Unlock your team&apos;s potential <SmallBreak /> and improve performance <SmallBreak />{" "}
          with Advante
        </Text>
        <Text
          fontSize={{ lg: "20px", base: "16px" }}
          lineHeight={{ lg: "32px", base: "24px" }}
          mb={"20px"}
          letterSpacing={{ base: "-0.02em" }}
        >
          Join now and unlock these benefits:
        </Text>
        <Grid
          templateColumns={{ xl: "2fr 1.2fr", lg: "2fr 1.4fr" }}
          gridRowGap={"20px"}
          mb={{ lg: "86px", base: "48px" }}
        >
          {offers.map((offer, idx) => {
            return (
              <GridItem
                key={idx}
                order={{ lg: ["1", "2", "3", "4", "5"][idx], base: ["1", "4", "2", "5", "3"][idx] }}
              >
                <HStack spacing={{ lg: "14px", base: "16px" }} alignItems={"center"}>
                  <Box>
                    <CheckIcon width={"20px"} height={"20px"} />
                  </Box>

                  <Text
                    fontSize={{ lg: "20px", base: "16px" }}
                    lineHeight={{ lg: "32px", base: "24px" }}
                    letterSpacing={{ base: "0.02em" }}
                  >
                    {offer}
                  </Text>
                </HStack>
              </GridItem>
            );
          })}
        </Grid>
        <Text
          fontSize={{ lg: "20px", base: "18px" }}
          lineHeight={{ lg: "32px", base: "30px" }}
          mb={{ lg: "20px", base: "16px" }}
        >
          Do you have any further inquiries?
        </Text>
        <Box>
          <Calendly bgColor={"#F9D209"} size="lg" w={{ base: "full", lg: "184px" }}>
            Schedule a call
          </Calendly>
        </Box>
      </Flex>
    </Box>
  );
};

export default Offer;

export function CheckIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 12.46L11 14.46L15.5 9.95996M17.9012 5.45847C18.1071 5.95649 18.5024 6.35236 19.0001 6.55903L20.7452 7.28194C21.2433 7.48824 21.639 7.88395 21.8453 8.38202C22.0516 8.88008 22.0516 9.4397 21.8453 9.93777L21.1229 11.6818C20.9165 12.18 20.9162 12.7402 21.1236 13.2383L21.8447 14.9818C21.9469 15.2284 21.9996 15.4929 21.9996 15.7599C21.9997 16.027 21.9471 16.2914 21.8449 16.5381C21.7427 16.7848 21.5929 17.009 21.4041 17.1978C21.2152 17.3866 20.991 17.5363 20.7443 17.6384L19.0004 18.3608C18.5023 18.5668 18.1065 18.962 17.8998 19.4597L17.1769 21.205C16.9706 21.703 16.575 22.0988 16.0769 22.3051C15.5789 22.5114 15.0193 22.5114 14.5212 22.3051L12.7773 21.5827C12.2792 21.3769 11.7198 21.3773 11.2221 21.5838L9.47689 22.3057C8.97912 22.5115 8.42001 22.5114 7.92237 22.3052C7.42473 22.0991 7.02925 21.7039 6.82281 21.2063L6.09972 19.4606C5.8938 18.9625 5.49854 18.5667 5.00085 18.36L3.25566 17.6371C2.75783 17.4309 2.36226 17.0354 2.15588 16.5376C1.94951 16.0398 1.94923 15.4805 2.1551 14.9825L2.87746 13.2385C3.08325 12.7404 3.08283 12.181 2.8763 11.6832L2.15497 9.93675C2.0527 9.69006 2.00004 9.42564 2 9.15859C1.99996 8.89155 2.05253 8.62711 2.15472 8.38039C2.25691 8.13368 2.40671 7.90951 2.59557 7.72071C2.78442 7.53191 3.00862 7.38218 3.25537 7.28006L4.9993 6.55768C5.49687 6.35193 5.89248 5.95716 6.0993 5.46002L6.82218 3.71477C7.02848 3.21671 7.42418 2.821 7.92222 2.61469C8.42027 2.40838 8.97987 2.40838 9.47792 2.61469L11.2218 3.33708C11.7199 3.54287 12.2793 3.54245 12.7771 3.33591L14.523 2.61581C15.021 2.40962 15.5804 2.40966 16.0784 2.61593C16.5763 2.82219 16.972 3.21779 17.1783 3.71572L17.9014 5.46149L17.9012 5.45847Z"
        stroke="#F9D209"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
